import { Injectable } from '@angular/core';
import { App } from '@df/core/app';
import { MultisiteService } from '@df/core/service/multisite';
import { AbstractDfModalInitiatorService } from '@df/ui/modal/abstract-df-modal-initiator.service';
import { ICmsModalService } from '@icms/client/assets/modal/icms-modal.service';
import { ICmsBlock, NICmsBlock } from '@icms/core/resource/block/icms-block';
import { ICmsBlockResource } from '@icms/core/resource/block/icms-block.resource';
import { NMultisiteModal } from './multisite-modal.interfaces';

@Injectable({
    providedIn: 'root'
})
export class MultisiteModalInitiatorService extends AbstractDfModalInitiatorService<NMultisiteModal.IInitiatorData> {
    constructor(
        cmsModalService: ICmsModalService,
        protected override app: App,
        private multisiteService: MultisiteService,
        private iCmsBlockResource: ICmsBlockResource
    ) {
        super(cmsModalService, app);
    }

    listen(cb: (data: NMultisiteModal.IInitiatorData) => void): Promise<void> {
        return new Promise(resolve => {
            if (!this.multisiteService.hasPreferredStore() && !this.multisiteService.noRedirect) {
                this.iCmsBlockResource
                    .retrieve(
                        {
                            bareUrl: NMultisiteModal.componentId
                        },
                        undefined
                    )
                    .then((block: ICmsBlock<NICmsBlock.IData<NMultisiteModal.IBlockContent>> | void) => {
                        if (block) {
                            this.app.customer.model
                                .load()
                                .then(a => {
                                    const geo = a.data.geo;

                                    if (geo) {
                                        if (
                                            block.data?.content.variants.find(store =>
                                                store.countries
                                                    ?.toUpperCase()
                                                    .split(',')
                                                    .find(i => i.trim() === geo)
                                            )
                                        ) {
                                            cb({ matchingCountry: geo });
                                        }
                                    }
                                })
                                .finally(() => resolve());
                        } else {
                            resolve();
                        }
                    })
                    .catch(() => resolve());
            } else {
                resolve();
            }
        });
    }
}
